// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__1o4ha","size":"styles_size__1ML41","pre_box":"styles_pre_box__3NACU","preBreath":"styles_preBreath__1dpQy","breath":"styles_breath__ZwX6f"};